import { FluxStandardAction } from "../../../__utils/type";
import * as Actions from "../../../constants/actions";

export const setInvestorDetail = (data: any): FluxStandardAction => {
    return {
        type: Actions.SET_INVESTOR_DETAILS,
        payload: {
            data: data,
        }
    }
};
export const verifyPincode = (pincode: string): FluxStandardAction => {
    return {
         type: Actions.FETCH_GET_VERIFY_PINCODE, 
         payload: {
            pincode: pincode
        }    
    }
};
export const fetchVerifyPincodeSuccess = (operationMessage: any): FluxStandardAction => {
    return {
        type: Actions.FETCH_GET_VERIFY_PINCODE_SUCCESS,
        payload: {
            operationMessage: operationMessage
        }
    }
};

export const fetchVerifyPincodeError = (error: any): FluxStandardAction => {
    return {
        type: Actions.FETCH_GET_VERIFY_PINCODE_ERROR,
        payload: {
            data: error
        }
    }
};